import { atom, selector } from "recoil";
import { createDataRequest, updateDataRequest } from "../../../api/controller/AnnualReportController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const annualReportListState = atom({
    key: 'annualReportListState',
    default: [],
})


export const modalConfigDefault = { size: "md", wizard: false }

export const filtersDefault = []

export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest } ],
    view: [ { name: 'Default View' } ],
}

export const annualReportDataStructureState = selector({
    key: 'annualReportDataStructureState',
    get: ({ get }) => (
        [
            { 
                label: 'Name',
                type: 'text',
                order: { table: 1 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
            { 
                label: 'Year',
                type: 'number',
                order: { form: 1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'File',
                type: 'file',
                order: { form: 2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
